import React from 'react';

import { Typography } from '@mui/material';
import { styled } from '@mui/material';

import StarEdgyFilledIcon from '~/assets/icons/StarEdgyFilledIcon';
import StarEdgyIcon from '~/assets/icons/StarEdgyIcon';
import useTenantTranslation from '~/hooks/useTenantTranslation';

interface RatingProps {
  value?: number;
  hideValue?: boolean;
  className?: string;
  name?: string;
}

const stars = new Array(5).fill(null);

const Rating = ({ value = 0, hideValue = false, className, name }: RatingProps) => {
  const { t } = useTenantTranslation();
  return (
    <Wrapper className={className}>
      {stars.map((s, i) =>
        i + 1 <= value ? (
          <FilledStarIcon data-testid={name + 'FilledIcon'} key={i} />
        ) : (
          <StarIcon data-testid={name + 'OutlinedIcon'} key={i} />
        ),
      )}
      {!hideValue ? (
        !value ? (
          <Caption>{t('page.video.noReviews')}</Caption>
        ) : (
          <Caption data-testid="ratingValue" variant="h3">
            {value?.toFixed(1)}
          </Caption>
        )
      ) : null}
    </Wrapper>
  );
};

export default Rating;

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
`;
const Caption = styled(Typography)`
  position: relative;
  top: -2px;
  margin-left: 6px;
  margin-bottom: 0;
  color: ${({ theme }) => theme.palette.common.accentFaded};

  && {
    font-weight: 400;
    font-size: 20px;
  }
`;
const createStyledStarIcon = (tag) => styled(tag)`
  width: 20px;
  height: 20px;
  margin-right: 6px;
  color: ${({ theme }) => theme.palette.common.accentFaded};

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 24px;
    height: 24px;
  }
`;
const StarIcon = createStyledStarIcon(StarEdgyIcon);
const FilledStarIcon = createStyledStarIcon(StarEdgyFilledIcon);
